const initialState = {
    tabType: '', // 当前选中的左侧菜单tab类型
    addressModalVisible: false, // 地址弹层是否展示
    processExchangeCurItem: {}, // 当前兑换元素
    organization: undefined, // 当前选中的机构id
    ruleModalVisible: false // 兑换规则弹窗是否展示
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RESET_DATA':
            return {
                ...state,
                ...initialState
            };
        case 'CHANGE_EXCHANGE_TAB_TYPE':
        case 'CHANGE_ADDRESS_MODAL_VISIBLE':
        case 'CHANGE_SAVE—_PROCESS_CUR_ITEM':
        case 'CHANGE_RULE_MODAL_VISIBLE':
        case 'CHANGE_ORGANIZATION':
        default:
            return {
                ...state,
                ...action.payload
            };
    }
};
